import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import iView from 'view-design'
import { setTitle } from '@/utils/util'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes
})

// interceptor before enter
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  next()
})

// interceptor after enter
router.afterEach(to => {
  setTitle(to)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
